import React, { Component } from 'react';

class RadioButtonCarteraColumn extends Component {
    constructor(props) {
        super(props);
        this.changeRadio = this.changeRadio.bind(this);
    }

    changeRadio(event) {
        let value = {
            codigo: this.props.Codigo,
            id: event.target.value
        }
        this.props.changeRadio("CARTERA", value);
    }

    render() {
        return (
            <div className="col-md-3" key={"rb" + this.props.Id} >
                <div className="container-radio radio-margin">
                    <input name="rb"
                        id={"rb" + this.props.Id}
                        value={this.props.Id}
                        type="radio"
                        onClick={this.changeRadio}
                        checked={this.props.checked} />
                    <label className="lbl-radio label-secondary"
                        htmlFor={"rb" + this.props.Id}>
                        {this.props.Codigo} - {this.props.Descripcion}
                    </label>
                </div>
            </div>
        );
    }
};

export default RadioButtonCarteraColumn